import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-org-employees',
  templateUrl: './org-employees.component.html',
  styleUrls: ['./org-employees.component.scss']
})
export class OrgEmployeesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
